import { render, staticRenderFns } from "./Eventi.vue?vue&type=template&id=3fce8368&"
import script from "./Eventi.vue?vue&type=script&lang=js&"
export * from "./Eventi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports